
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Review } from "@/hooks/useReviewsQuery";

interface ReviewListProps {
  reviews: Review[];
}

export const ReviewList = ({ reviews }: ReviewListProps) => {
  // Function to render stars with brand colors
  const renderStars = (rating: number) => {
    return Array(5)
      .fill(0)
      .map((_, i) => (
        <Star
          key={i}
          className={`w-3 h-3 md:w-4 md:h-4 ${
            i < rating
              ? "fill-current"
              : "text-gray-300"
          }`}
          style={{ color: i < rating ? 'var(--brand-color-3, #91DA73)' : undefined }}
        />
      ));
  };

  if (!reviews || reviews.length === 0) {
    return (
      <p className="text-sm text-gray-500 text-center py-4">
        No reviews available.
      </p>
    );
  }

  return (
    <div className="space-y-3 md:space-y-4">
      {reviews.map((review) => (
        <Card key={review.id} className="bg-white">
          <CardContent className="p-3 md:p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-800">
                {review.customer_name || "Anonymous"}
              </span>
              <div className="flex items-center">
                {renderStars(review.rating)}
              </div>
            </div>
            {review.comment && (
              <p className="text-xs md:text-sm text-gray-700 mt-1 md:mt-2">
                {review.comment}
              </p>
            )}
            <div className="text-xs text-gray-500 mt-2">
              {new Date(review.created_at).toLocaleDateString()}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
